import { render } from "./EmpresaGeneral.vue?vue&type=template&id=a4f32c88&scoped=true"
import script from "./EmpresaGeneral.vue?vue&type=script&lang=js"
export * from "./EmpresaGeneral.vue?vue&type=script&lang=js"

import "./EmpresaGeneral.vue?vue&type=style&index=0&id=a4f32c88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4f32c88"

export default script